import { Injectable } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { ObterPendentes, Remover } from './notificacao-store/notificacao.actions';
import { NotificacaoSelectors } from './notificacao-store/notificacao.selectors';
import { NotificacaoModel } from './notificacao.model';
import { Router } from '@angular/router';
import { TipoNotificacao } from "./notificacao-enum";

@Injectable({
    providedIn: 'root'
})
export class NotificacaoService {
    
    @Select(NotificacaoSelectors.notificacoes) public notificacoes$: Observable<NotificacaoModel[]>;
    
    constructor(private router: Router, private store: Store) {
    
    }
    
    public obterPendentes = () => this.store.dispatch(new ObterPendentes());
    public remover = (tipo: TipoNotificacao) => this.store.dispatch(new Remover(tipo));
    
    //TODO - Refatorar esse componente de forma genérica e deixar a regra de negócio no Back
    public navegarPara(tipo: string) {
        switch (tipo) {
            case TipoNotificacao.MudancaAtributoRfb:
                return this.router.navigate(['/atributos-modificados']);
            case TipoNotificacao.ProcessamentoImportacaoProdutos:
            case TipoNotificacao.ProcessamentoImportacaoOperadores:
            case TipoNotificacao.ProcessamentoCapturaFabricantesPortalUnico:
            case TipoNotificacao.ProcessamentoCapturaOperadoresEstrangeirosPortalUnico:
            case TipoNotificacao.ProcessamentoCapturaProdutosPortalUnico:
                return this.router.navigate(['/importacao-dados']);
            case TipoNotificacao.ProcessamentoSugestaoPreenchimentoSaneamento:
            case TipoNotificacao.ProcessamentoImportacaoPreenchimentoSaneamento:
            case TipoNotificacao.ProcessamentoExportacaoPreenchimentoSaneamento:
                return this.router.navigate(['/saneamento/saneamento-atributo']);
            case TipoNotificacao.ProcessamentoExportacaoAtributosModificados:
                return this.router.navigate(['/atributos-modificados']);
            case TipoNotificacao.ProcessamentoExportacaoOperadoresEstrangeiros:
                return this.router.navigate(['/operador-estrangeiro']);
            case TipoNotificacao.ProcessamentoExportacaoProdutos:
                return this.router.navigate(['/produto']);
            case TipoNotificacao.ProcessamentoExportacaoProdutoVersoes:
                return this.router.navigate(['/catalogo']);
            case TipoNotificacao.ProcessamentoExportacaoRelatorio:
                return this.router.navigate(['/relatorio']);
            case TipoNotificacao.ProcessamentoExportacaoSaneamentoAuditoria:
            case TipoNotificacao.ProcessamentoImportacaoSaneamentoAuditoria:
                return this.router.navigate(['/saneamento/auditoria']);
            default:
                break;
        }
        return;
    }
}
